<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">
                <gj-country-server-select
                        v-model="filter.countryMarketValue"
                >
                </gj-country-server-select>
                <gj-select
                        placeholder="退货原因"
                        collapse-tags
                        v-model="filter.reason"
                        :width="'130px'"
                        :options="RETURN_REASON_OPTIONS"
                />

                <gj-select-input
                        v-model="filter.keyword"
                        :width="['100px', '160px']"
                        :options="[
                       {id: 'asin', text: 'ASIN', moreShow: true},
                       {id: 'msku', text: 'MSKU'},
                       {id: 'sku', text: 'SKU'},
                       {id: 'fnsku', text: 'FNSKU'},
                       {id: 'orderId', text: '订单编号', moreShow: true}
                   ]"
                >
                </gj-select-input>

                <gj-select-date-picker
                        v-model="filter.date"
                        type="daterange"
                        :options="[
                            {id: 'returnMarketDate', text: '退货时间(站点时区)'},
                            {id: 'returnZeroDate', text: '退货时间(零时区)'},
                            {id: 'purchaseDate', text: '订购时间(站点时区)'}
                        ]"
                        :width="['150px']"
                >
                </gj-select-date-picker>


                <template #right>
                    <gj-tool-group
                            help
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('customerReturn:export')" download-url="/operation/customerReturn/export"
                            :download-params="globalParams"
                    >
                    </gj-tool-group>
                    <view-setting
                            :ref="REF_VIEW_SETTING"
                            save-mode="remote"
                            :use-default="true"
                            :module-name="moduleName"
                            :config="model"
                            :fn-generate-params="generateViewParams"
                            @view-change="handleChangeView"
                            @view-complete="handCompleteView"
                    >
                    </view-setting>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :default-sort="{prop: 'marketTime', order: 'descending'}"
                    show-summary
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:orderId="{row}">
                    <el-row
                        type="flex"
                        align="middle">
                        <div>
                            <gj-button v-if="$permission('order:view')" type="text" @click="opDetailModal(row)">{{row.orderId}}</gj-button>
                            <span v-if="!$permission('order:view')">{{row.orderId}}</span>
                        </div>
                        <gj-copy-icon v-if="isMeaningful(row.orderId)" :content="row.orderId"/>
                    </el-row>
                </template>
                <template v-slot:asin="{row}">
                    <gj-tooltip :text-line="1" :content="row.productName">
                        {{row.productName | defaultShow}}
                    </gj-tooltip>
                    <el-row>
                        <el-col :span="24">
                            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                            <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                        </el-col>
                    </el-row>
                </template>
                <template v-slot:sku="{row}">
                    <gj-tooltip :text-line="1" :content="row.skuName" v-if="row.sku">
                        {{row.skuName | defaultShow}}
                    </gj-tooltip>
                    <el-row type="flex">
                        <RelateProductComponent :data="row" />
                    </el-row>
                </template>
                <template v-slot:msku="{row}">
                    <div class="text-ellipsis-1">{{row.fnsku | defaultShow}}
                        <gj-copy-icon v-if="isMeaningful(row.fnsku)" :content="row.fnsku" />
                    </div>
                    <div class="text-ellipsis-1">{{row.msku | defaultShow}}
                        <gj-copy-icon v-if="isMeaningful(row.msku)" :content="row.msku" />
                    </div>
                </template>
                <!-- 标签 -->
                 <template v-slot:tags="{row}">
                        <div style="display:flex">
                            <gj-tooltip :text-line="1" effect="light" popperClass="lightTip">
                                <template #content>
                                    <div class="contenBox">
                                        <div class="paddBox">
                                            <span v-for="(item,index) in row.tags" :key="index" class="tagSpan">
                                                <gj-tag :color="tagColors.orange" type="plain" class="contentLongTag">{{item.name}}</gj-tag>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <span v-for="(item,index) in row.tags" :key="index" class="tagSpan">
                                    <gj-tag :color="tagColors.orange" type="plain" class="tooLongTag">{{item.name}}</gj-tag>
                                </span>
                            </gj-tooltip>
                            <div  v-if="$permission('review:marking')" class="editIcon" :class="{'gj-cell-display-switch': tableCellEdit}"
                                @click="editTags(row)">
                                <i class="el-icon-edit"></i>
                            </div>
                        </div>
                    </template>
              <template v-slot:customerComments="{row}">
                <gj-tooltip :text-line="2" :content="row.customerComments">
                  {{row.customerComments | defaultShow}}
                </gj-tooltip>
              </template>
              <template v-slot:status="{row}">
                <gj-tooltip :text-line="2" :content="row.status">
                  {{row.status | defaultShow}}
                </gj-tooltip>
              </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {isMeaningfulMixin, queryMixin} from "@/minxins";
    import {isMeaningful} from "@/utils/common";
    import SaleOrderDetail from "../saleOrder/modal/sale-order-detail";
    import {
        exportCustomerReturn,
        getCustomerReturnPage
    } from "@/api/sale";
    import {convertToDate, generateViewParams} from "@/utils/date.util";
    import { RETURN_REASON_OPTIONS } from '@/utils/options'
    import model from './viewConfig'
    import { RelateProductComponent }from '@/views/components/relate-product/index'
    import EditTagsModal from './edit-tags-modal'
    import { tagColors } from '@/components/tag/tag-colors'

    export default {
        name: "app-customerReturn",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {
            RelateProductComponent
        },
        data() {
            return {
                tagColors,
                tableName: 'customerReturn',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    // {marketName: 'aa', asin: 'asin1'}
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', default: true, disabled: true, fixed: 'left'},
                    {id: 'orderId', header: '订单编号', field: 'slot:orderId', minWidth: '160px', default: true, fixed: 'left'},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true, fixed: 'left'},
                    {id: 'asin', header: '商品标题/ASIN', field: 'slot:asin', minWidth: '185px', default: true, fixed: 'left'},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', default: true},
                    {id: 'msku', header: 'FNSKU/MSKU', field: 'slot:msku', sortable: true, minWidth: '170px', default: true},
                    {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '100px', default: true},
                    {id: 'marketTime', header: '退货时间', field: 'marketTime', sortable: true, minWidth: '155px', help: '站点时区', default: true},
                    {id: 'zeroZoneTime', header: '退货时间', field: 'zeroZoneTime', sortable: true, minWidth: '155px', help: '零时区', default: true},
                    {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', sortable: true, minWidth: '155px', help: '站点时区', default: true},
                    {id: 'quantity', header: '退货数量', field: 'quantity', sortable: true, minWidth: '90px', align: 'right', summary: true, default: true},
                    {id: 'fulfillmentCenterId', header: '亚马逊仓库代码', field: 'fulfillmentCenterId', minWidth: '110px', default: true},
                    {id: 'detailedDisposition', header: '库存属性', field: 'detailedDisposition', minWidth: '110px', default: true},
                    {id: 'reason', header: '退货原因', field: 'reason', minWidth: '100px', overflowLine: 2, default: true},
                    {id: 'tags', header:'标签', field:'slot:tags',minWidth:'120px',default:true},
                    {id: 'customerComments', header: '买家备注', field: 'slot:customerComments',  minWidth: '110px', default: true},
                    {id: 'status', header: '退货状态', field: 'slot:status', minWidth: '100px', default: true},
                    {id: 'licensePlateNumber', header: 'LPN', field: 'licensePlateNumber', minWidth: '140px', default: true}
                ],
                tableData: [],
                tableCellEdit:true,
                filter: {
                    countryMarketValue: null,
                    reason: null,
                    keyword: {
                        key: 'asin', value: null, popover: false
                    },
                    date: {
                        key: 'returnMarketDate', value: null,
                    },
                },
                treeData: [{
                    id: 0, label: '00'
                }],
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                RETURN_REASON_OPTIONS,
                moduleName: 'CUSTOMER_RETURN',
                model,
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = 'marketTime';
        },
        methods: {
            generateViewParams,
            loadViewComplete () {
                this.$emit('query')
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{countryMarketValue: *}}
             */
            $gjCacheCallback(params) {
                return {
                    countryMarketValue: params.countryMarketValue
                };
            },
            $gjQueryInitParams() {

                try {
                    let { param = '' } = this.$route.query

                    param = JSON.parse(param)
                    return {
                        filter: {
                            countryMarketValue: {
                                countryIds: param.countryCodes,
                                marketIds: param.marketIds
                            },
                            reason: null,
                            keyword: {
                                key: 'asin', value: param.asinCode, popover: false
                            },
                            date: {
                                key: 'returnMarketDate', value: [param.startDateTime || '', param.endDateTime || ''],
                            },
                        }
                    };

                } catch (e) {
                    return {
                        filter: {
                            countryMarketValue: null,
                            reason: null,
                            keyword: {
                                key: 'asin', value: null, popover: false
                            },
                            date: {
                                key: 'returnMarketDate', value: null,
                            },
                        }
                    }
                }

            },
            editTags(row){
                this.$gjCreate(EditTagsModal,{
                    props:{
                        tag:row
                    },
                    on:{
                        created:()=>{
                            this.$gjQuery()
                        }
                    }
                })
            },
            $gjQuery() {
                this.filter.keyword.popover = false
                // 构造查询参数
                const params = {
                    model: {
                        reason: this.filter.reason
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                // 关键词查询
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                // 店铺国家
                if (this.filter.countryMarketValue) {
                    params.model.countrys = this.filter.countryMarketValue.countryIds;
                    params.model.marketIds = this.filter.countryMarketValue.marketIds;
                }
                // 时间
                if (isMeaningful(this.filter.date.value)) {
                    if (this.filter.date.key === 'returnMarketDate') {
                        params.model.startReturnMarketTime = convertToDate(this.filter.date.value[0]);
                        params.model.endReturnMarketTime = convertToDate(this.filter.date.value[1]);
                    } else if (this.filter.date.key === 'returnZeroDate') {
                        params.model.startReturnZeroZoneTime = convertToDate(this.filter.date.value[0]);
                        params.model.endReturnZeroZoneTime = convertToDate(this.filter.date.value[1]);
                    } else if (this.filter.date.key === 'purchaseDate') {
                        params.model.startPurchaseMarketTime = convertToDate(this.filter.date.value[0]);
                        params.model.endPurchaseMarketTime = convertToDate(this.filter.date.value[1]);
                    }
                }
                this.globalParams = params;
                // 查询
                this.loading = true;
                getCustomerReturnPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportCustomerReturn(this.globalParams);
            },
            opDetailModal(row) {
                this.$gjCreate(SaleOrderDetail, {
                    props: {
                        marketId: row.marketId,
                        orderId: row.orderId,
                    }
                })
            },
        },
    }
</script>

<style scoped>
.contentLongTag{
    max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
}
    .tooLongTag{
        max-width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .tagSpan{
        display: inline-block;
        margin-bottom: 3px;
    }
.editIcon{
    cursor: pointer;
    position: relative;
    top:3px
}
.contenBox{
    max-width: 640px;
    max-height: 120px;
    overflow-y: auto;
}
.paddBox{
  padding: 10px 10px 3px;
}
</style>
